module.exports = __webpack_public_path__ + "img/ex1.eb65c5df.png";